import React from "react";
import { motion } from "framer-motion";
import { getThemeClass } from "../../../../lib/theme";
import { cn } from "../../../../lib/utils";

interface HeroSectionProps {
  title: string;
  subtitle: string;
  className?: string;
  animate?: boolean;
}

const HeroRibbon: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  className = "",
  animate = false,
}) => {
  const content = (
    <section className={cn("relative py-16", getThemeClass("gradients.hero"))}>
      {/* Dot matrix overlay - now consistent across all pages */}
      <div className="absolute inset-0 opacity-10 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTAiIGN5PSIxMCIgcj0iMSIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==')]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1
          className={cn(
            "text-4xl font-bold mb-4",
            getThemeClass("colors.text.light")
          )}
        >
          {title}
        </h1>
        <p
          className={cn(
            "text-lg md:text-l max-w-3xl leading-relaxed",
            getThemeClass("colors.text.light")
          )}
        >
          {subtitle}
        </p>
      </div>
    </section>
  );

  if (!animate) {
    return content;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className={className}
    >
      {content}
    </motion.div>
  );
};

export default HeroRibbon;
